import axios from 'axios';
import { getAutoSuggestApiBaseUrl } from '../utils/appConfig';

export default axios.create({
  baseURL: getAutoSuggestApiBaseUrl()
});
